import React from 'react';
import { CONTACT_PHONE_WHATSAPP } from '../../../constants/contact';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const handleWhatsAppClick = () => {
    const message = 'Hello! I would like to schedule a consultation for rhinoplasty surgery.';
    const whatsappUrl = `https://wa.me/${CONTACT_PHONE_WHATSAPP}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-button" onClick={handleWhatsAppClick}>
      <i className="fab fa-whatsapp"></i>
      <span className="whatsapp-tooltip">Chat with us on WhatsApp</span>
    </div>
  );
};

export default WhatsAppButton;
